import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRoute } from 'vue-router/composables';
import WatchlistInnerTabNavigation from '@/components/watchlist/WatchlistInnerTabNavigation.vue';
import { CollectionType } from '@/enums/collection-type';
import { TabType } from '@/interfaces/inner-tabs';
import { useFilterStore, useRoutingStore } from '@/helpers/composables/useStores';
import { useI18n } from '@/helpers/composables/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicLists',
  emits: ["scrollToTop"],
  setup(__props, { emit }: { emit: ({ (event: 'scrollToTop'): void }), expose: any, slots: any, attrs: any }) {

const FollowedLists = () =>
	import(/* webpackChunkName: "followed-lists" */ '@/components/watchlist/public-lists/FollowedLists.vue');
const RecommendedLists = () =>
	import(/* webpackChunkName: "recommended-lists" */ '@/components/watchlist/public-lists/RecommendedLists.vue');
const PublicListDetails = () =>
	import(/* webpackChunkName: "public-list-details" */ '@/components/watchlist/public-lists/PublicListDetails.vue');



const { currentFilters } = useFilterStore();
const { setLastActiveListsCollectionType } = useRoutingStore();
const route = useRoute();
const { tc } = useI18n();

setLastActiveListsCollectionType(CollectionType.PUBLIC_LISTS);

const selectedListId = computed(() => {
	const listId = route.query?.list_id;

	return listId || null;
});

const innerTabFilter = computed(() => {
	return currentFilters.value.inner_tab || TabType.BROWSE;
});

const innerTabs = computed(() => {
	return [
		{
			key: TabType.FOLLOWING,
			translation: `${tc('WEBAPP_LISTS_FOLLOWING')}`,
		},
		{
			key: TabType.BROWSE,
			translation: `${tc('WEBAPP_LISTS_BROWSE')}`,
		},
	];
});

function scrollToTop() {
	emit('scrollToTop');
}

return { __sfc: true,FollowedLists, RecommendedLists, PublicListDetails, emit, currentFilters, setLastActiveListsCollectionType, route, tc, selectedListId, innerTabFilter, innerTabs, scrollToTop, WatchlistInnerTabNavigation }
}

})